module.exports = __webpack_public_path__ + "static/media/goal_flag.014b9a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/goal_flag.png
// module id = 8445
// module chunks = 0